/**
* @class that generates a random number
* @version 1.1
*/
class Random_Number
{
  constructor( { max = 4, min = 0, max_attempts = 50 } = {} )
  {
    const self = this;
    self.max = max;
    self.min = min;
    self.max_attempts = max_attempts;
    self.prev_number = null;
    self.matches = [];
    self.new_number_condtion = self.new_number_condtion.bind(this);
    self.check_previous_number_condtion = self.check_previous_number_condtion.bind(this);
  }

  get()
  {
    const self = this;

    self.check_matches();
    // check first number doesnt match last number of the previous batch
    self.new_number = self.new_number ? self.new_number : self.generate_unique_number( self.check_previous_number_condtion );

    self.generate_unique_number( self.new_number_condtion);

    self.update_matches( self.new_number );

    self.prev_number = self.new_number;

    return self.new_number;
  }

  update_matches( new_number )
  {
    const self = this;
    // add new number to matches
    if ( !self.matches.includes( new_number ) )
    {
      self.matches.push( new_number );
    }
  }

  update_max( new_max )
  {
    const self = this;
    self.max = new_max;
    return self;
  }

  generate_unique_number( condition )
  {
    const self = this;
    let attempts;
    attempts = 1;
    while ( condition( attempts ) )
    {
      self.new_number = self.generate_number();
      attempts++;
    }
    return self.new_number;
  }

  generate_number()
  {
    const self = this;
    return Math.floor(( Math.random() * ( self.max - self.min + 1 )) + self.min );
  }

  check_matches()
  {
    const self = this;
    // reset array if the length equals self.max
    if ( self.matches.length === ( self.max - self.min ) + 1 )
    {
      self.matches = [];
      self.new_number = null;
    }
  }

  new_number_condtion ( attempts )
  {
    const self = this;
    return attempts <= self.max_attempts && self.matches.includes( self.new_number );
  }

  check_previous_number_condtion ( attempts )
  {
    const self = this;
    return attempts <= (self.max_attempts && !self.new_number && self.new_number !== 0) || (attempts <= self.max_attempts && self.new_number === self.prev_number);
  }
}

